import React, { useState, useEffect } from 'react';
import { collection, addDoc, onSnapshot, deleteDoc, doc, serverTimestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { FaPlus, FaTrash, FaImage } from 'react-icons/fa';
import './CategoryManager.css';
import { db, storage } from '../firebase/firebase-config';

const CategoryManager = () => {
  const [categories, setCategories] = useState([]);
  const [newCat, setNewCat] = useState({ title: '' });
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);

  // Türkçe karakterleri temizleyen sihirli fonksiyon kanka
  const createSlug = (text) => {
    const trMap = {
      'ç':'c', 'ğ':'g', 'ş':'s', 'ü':'u', 'i':'i', 'ö':'o',
      'Ç':'C', 'Ğ':'G', 'Ş':'S', 'Ü':'U', 'İ':'I', 'Ö':'O'
    };
    for (let key in trMap) {
      text = text.replace(new RegExp(key, 'g'), trMap[key]);
    }
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '') // Alfanümerik olmayanları siler
      .replace(/[\s_-]+/g, '-') // Boşlukları tire yapar
      .replace(/^-+|-+$/g, ''); // Baştaki ve sondaki tireleri siler
  };

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "categories"), (snap) => {
      setCategories(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsub();
  }, []);

  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!newCat.title || !image) return alert("Kanka hem başlık hem de kapak görseli şart!");

    setLoading(true);
    try {
      // 1. Kapak Fotoğrafını Storage'a Yükle
      const imageRef = ref(storage, `category_covers/${Date.now()}_${image.name}`);
      await uploadBytes(imageRef, image);
      const imageUrl = await getDownloadURL(imageRef);

      // 2. Güvenli Slug Oluştur
      const safeSlug = createSlug(newCat.title);

      // 3. Firestore'a Kaydet
      await addDoc(collection(db, "categories"), {
        title: newCat.title,
        slug: safeSlug, // Artık "kesme-iscilik" olarak kaydedilecek
        coverImg: imageUrl,
        createdAt: serverTimestamp()
      });

      setNewCat({ title: '' });
      setImage(null);
      alert("Koleksiyon başarıyla eklendi kanka!");
    } catch (err) {
      console.error(err);
      alert("Yüklerken bir hata çıktı.");
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Bu koleksiyonu silmek istediğine emin misin kanka?")) {
      await deleteDoc(doc(db, "categories", id));
    }
  };

  return (
    <div className="category-manager">
      <h2 className="admin-section-title">Koleksiyon & Kategori Yönetimi</h2>
      
      <form onSubmit={handleAddCategory} className="add-cat-form-premium">
        <div className="cat-input-wrapper">
          <input 
            type="text" 
            placeholder="Kategori Adı (Örn: Osmanlı Sıkma)" 
            value={newCat.title}
            onChange={(e) => setNewCat({ title: e.target.value })}
            required
          />
          
          <label className="cat-file-label">
            <FaImage /> {image ? "Görsel Seçildi" : "Kapak Görseli Seç"}
            <input 
              type="file" 
              onChange={(e) => setImage(e.target.files[0])} 
              hidden 
              accept="image/*"
            />
          </label>
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "YÜKLENİYOR..." : <><FaPlus /> KOLEKSİYON EKLE</>}
        </button>
      </form>

      <div className="cat-list-grid">
        {categories.map((cat) => (
          <div key={cat.id} className="cat-item-card-premium">
            <div className="cat-card-img">
              <img src={cat.coverImg} alt={cat.title} />
              <div className="cat-card-overlay">
                <span>{cat.title}</span>
              </div>
            </div>
            <button onClick={() => handleDelete(cat.id)} className="cat-delete-btn">
              <FaTrash />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryManager;